import { createSelector } from 'reselect';
import Resdit7421PerformanceCarrierPercentageColumns from '../../containers/Resdit7421PerformanceCarrierPercentageColumns';
import Resdit7421PerformanceCarrierNumberColumns from '../../containers/Resdit7421PerformanceCarrierNumberColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.RESDIT_74_21_PERFORMANCE_CARRIER_107B.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.RESDIT_74_21_PERFORMANCE_CARRIER_107B.isLoading;

export const getData =
  ReportDefinitions.RESDIT_74_21_PERFORMANCE_CARRIER_107B.getDataFunction();

export const getPercentageColumns =
  // eslint-disable-next-line max-len
  createSelector(getData, state => state.reporting.RESDIT_74_21_PERFORMANCE_CARRIER_107B.requestParams, Resdit7421PerformanceCarrierPercentageColumns);

export const getNumberColumns =
  // eslint-disable-next-line max-len
  createSelector(getData, state => state.reporting.RESDIT_74_21_PERFORMANCE_CARRIER_107B.requestParams, Resdit7421PerformanceCarrierNumberColumns);
